module.exports = __webpack_public_path__ + "static/media/gasStationFill.3dbba733.svg";